import { SaveOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Tabs,
} from "antd";
import { Store } from "antd/lib/form/interface";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  DefaultErrorMessage,
  Successfully,
  UpdateDataSuccessfully,
  NotificationText,
  Save,
  TimeZone,
} from "shared/constants/define-localization";
import { t, CoreResource } from "shared/plugins/localization";
import { setLoading } from "states/global-value/global-value.slice";
import { getFirebaseConfig, updateFirebaseConfig } from "states/google-setting/google-setting.api";
import { GoogleFirebaseConfigModel } from "states/google-setting/google-setting.models";
import {
  getSystemConfig,
  getTimeZones,
  updateSystemConfig,
} from "states/system-setting/system-setting.api";
import {
  SystemConfigModel,
  TimezoneModel,
} from "states/system-setting/system-setting.models";

export function FirebaseConfig() {
  const [form] = Form.useForm<GoogleFirebaseConfigModel>();
  const dispatch = useDispatch();

  const getConfig = async () => {
    try {
      const res = await getFirebaseConfig();
      form.setFieldsValue(res.data);
    } catch (error) {
      message.error(
        error?.response?.data?.error?.message ??
          "Lỗi hệ thống"
      );
    }
  };

  const onFinish = async (values: GoogleFirebaseConfigModel) => {
    dispatch(setLoading(true));
    try {
      let payload = {
        ...values,
        projectId:values.projectId,
        privateKey: values.privateKey,
        clientEmail: values.clientEmail,
        apiKey: values.apiKey,
        authDomain: values.authDomain,
        storageBucket: values.storageBucket,
        messagingSenderId: values.messagingSenderId,
        appId: values.appId,
        measurementId: values.measurementId,
      } as GoogleFirebaseConfigModel;
      await updateFirebaseConfig(payload);
      dispatch(setLoading(false));
      Modal.success({
        title: "Thành công",
        content: "Cập nhật thành công",
      });
    } catch (error) {
      dispatch(setLoading(false));
      Modal.error({
        title: "Thông báo",
        content:
          error?.response?.data?.error?.message ??
          "Lỗi hệ thống",
      });
    }
  };
  const onSaved = () => {
    form.submit();
  };
  useEffect(() => {
    getConfig();
  }, []);

  return (
    <div className="website-config">
      <Tabs type="card">
        <Tabs.TabPane tab="Cấu hình firebase" key="fire-base">
          <Row gutter={[16, 16]} className="mb-4">
            <Col flex="auto"></Col>
            <Col flex="auto" className="d-flex justify-content-end">
              <Button onClick={onSaved} type="primary" icon={<SaveOutlined />}>
                {"Lưu"}
              </Button>
            </Col>
          </Row>
          <Row gutter={[16, 16]} justify="space-between">
            <Col span={24}>
              <Card title="Cấu hình firebase" bordered={false}>
                <Form
                  form={form}
                  name="website-config"
                  onFinish={onFinish}
                  layout="vertical"
                >
                  <Form.Item label="Project Id" name="projectId">
                    <Input placeholder="Project Id" />
                  </Form.Item>
                  <Form.Item label="Private Key" name="privateKey">
                    <Input placeholder="Private Key" />
                  </Form.Item>
                  <Form.Item label="Client Email" name="clientEmail">
                    <Input placeholder="Client Email" />
                  </Form.Item>
                  <Form.Item label="Api Key" name="apiKey">
                    <Input placeholder="Api Key" />
                  </Form.Item>
                  <Form.Item label="Auth Domain" name="authDomain">
                    <Input placeholder="Auth Domain" />
                  </Form.Item>
                  <Form.Item label="Storage Bucket" name="storageBucket">
                    <Input placeholder="Storage Bucket" />
                  </Form.Item>
                  <Form.Item label="MessagingSenderId" name="messagingSenderId">
                    <Input placeholder="MessagingSenderId" />
                  </Form.Item>
                  <Form.Item label="App Id" name="appId">
                    <Input placeholder="App Id" />
                  </Form.Item>
                  <Form.Item label="Measurement Id" name="measurementId">
                    <Input placeholder="Measurement Id" />
                  </Form.Item>
                </Form>
              </Card>
            </Col>
          </Row>
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}
